// extracted by mini-css-extract-plugin
export default {"zoomModal":"U3-z","image":"V3-z","button":"W3-z","isOverlayShown":"X3-z"};